import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import '../../../static/less/extras/extra.less';
import PaxTypeSelector from '../../common/PaxTypeSelector';
/*import {
  CALL_CENTER_ROLE,
} from '../../../constants';*/

class PaxSelector extends React.Component {
  constructor(props) {
    super(props);
    const roomUse = props.cart.cartHotel.rooms[0].use_alt;
    const room = props.cart.cartHotel.rooms[0];
    room.max_adults = roomUse.adults;
    room.max_childs = roomUse.children;
    room.max_infants = roomUse.infants;
    room.max_pax = roomUse.adults + roomUse.children + roomUse.infants;
    this.state = {
      totalPax: roomUse.adults + roomUse.children,
      adults: props.currentPax.adults,
      childs: props.currentPax.childs,
      infants: props.currentPax.infants,
      room,
    };

    this.onClickUpdatePax = this.onClickUpdatePax.bind(this);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
  }

  componentDidMount() {
  }

  onClickUpdatePax(paxKey, diff) {
    // Update paxes of the selected type, and the total occupants (babies do not count for it)
    const newPaxNumber = this.state[paxKey] + diff;
    const isInfants = paxKey === 'infants';
    const newTotalPax = isInfants ? this.state.totalPax : this.state.totalPax + diff;

    const stateUpdate = {
      [paxKey]: newPaxNumber,
      totalPax: newTotalPax,
    };

    // We allow selecting an occupancy below the minimum, but a message will be shown
    stateUpdate.invalidSelection = newTotalPax < this.state.room.min_pax;
    this.setState(stateUpdate);
    // Update parent state
    this.props.paxUpdated(paxKey, newPaxNumber);
  }

  renderAdultControls() {
    const { cart } = this.props;
    const hotel = cart.cartHotel;

    return (
      <PaxTypeSelector paxKey="adults" paxNum={this.state.adults} totalPax={this.state.totalPax}
                       hotel={hotel} room={this.state.room}
                       onClick={this.onClickUpdatePax}
                       typeExtra={this.props.extra.type[0].type_extra} />
    );
  }

  renderChildrenControls() {
    const { cart } = this.props;
    const hotel = cart.cartHotel;
    if (this.state.room.max_childs === 0) {
      return null;
    }
    return (
      <PaxTypeSelector paxKey="childs" paxNum={this.state.childs} totalPax={this.state.totalPax}
                       hotel={hotel} room={this.state.room}
                       onClick={this.onClickUpdatePax}
                       typeExtra={this.props.extra.type[0].type_extra} />
    );
  }

  renderInfantsControls() {
    const { cart } = this.props;
    const hotel = cart.cartHotel;
    if (this.state.room.max_infants === 0) {
      return null;
    }
    return (
      <PaxTypeSelector paxKey="infants" paxNum={this.state.infants} totalPax={this.state.totalPax}
                       hotel={hotel} room={this.state.room}
                       onClick={this.onClickUpdatePax}
                       typeExtra={this.props.extra.type[0].type_extra} />
    );
  }

  render() {
    const { hotel, hasTitle } = this.props;
    const { isCallCenterUser } = this.props;
    return (
      <div className={`${isCallCenterUser ? 'flex sm:flex-wrap sm:w-1/4' : 'pax-selector'}`}>
        <div className={hasTitle ? 'pax-selector__title' : 'hidden'} style={{ paddingBottom: '20px' }}>
          {this.context.t('Passengers')}:
        </div>
        <div style={{ paddingLeft: '0.5rem' }}>
          {this.renderAdultControls(hotel)}
          {this.renderChildrenControls(hotel)}
          {this.renderInfantsControls(hotel)}
        </div>
      </div>
    );
  }
}

PaxSelector.contextTypes = {
  extra: PropTypes.object,
  currentPax: PropTypes.object,
  hasTitle: PropTypes.bool,
  router: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  lang: state.i18nState.lang,
  cart: state.cart,
  hotel: state.booking.hotel,
  isCallCenterUser: false, //state.session.user.role === CALL_CENTER_ROLE,
}))(PaxSelector);
